<template>
  <v-slider
            v-model="selected"
            tick-size=0
            thumb-label="always"
            :min="min"
            :max="max"
            step="0"
            :class="sliderClass"
            :readonly="disabled"
            @change="onChangedValue"
  >
              <template v-slot:thumb-label="{ value }">
                {{ getLabel(value) }}
              </template>
  </v-slider>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class DynameatSlider extends Vue {
  @Prop({ type: String, default: 'defaultSlider' }) id

  @Prop({ type: Number, default: 0 }) min

  @Prop({ type: Number, default: 1 }) max

  @Prop({ type: Number, default: 0, }) value

  @Prop({ type: Boolean, default: false }) disabled

  @Prop({
    type: Array,
    required: true,
    validator(value) {
      return (Array.isArray(value) && value.length !== 0);
    }
  }) ranges

  selected = 0

  get sliderClass() {
    if (this.disabled) return 'mx-8 disabled-slider';
    return 'mx-8 enabled-slider';
  }

  get limits() {
    let limits = [];
    limits = [...Array(this.ranges.length).keys()];
    limits = limits.map((v) => v / limits.length);
    limits = limits.map((v) => v * (this.max - this.min) + this.min);
    return limits;
  }

  @Watch('value')
  onValueChange(newVal) {
    this.selected = newVal;
  }

  created() {
    this.selected = this.value;
  }

  getRange(value) {
    const found = this.limits.reduce(((prev, curr) => ((value > curr) ? curr : prev)));
    return this.limits.indexOf(found);
  }

  getLabel(value) {
    return (this.ranges[this.getRange(value)]);
  }

  onChangedValue(value) {
    const found = this.getRange(value);
    let selected;
    if (found === 0) {
      selected = this.min;
    } else if (found === this.limits.length - 1) {
      selected = this.max;
    } else {
      selected = (this.limits[found + 1] + this.limits[found]) / 2;
    }
    this.$emit('sliderChanged', { id: this.id, value: selected });
    this.$nextTick(() => {
      this.selected = selected;
    });
  }
}
</script>
<style scoped>
.disabled-slider {
  max-height: 35px;
  margin-top: 20px;
  filter: grayscale(100%);
  opacity: 0.3;
}
.enabled-slider {
  max-height: 35px;
  margin-top: 20px;
}
</style>

<style>
.v-slider--horizontal .v-slider__thumb-label {
  -webkit-transform: translateY(-20%) translateY(-12px) translateX(-50%) !important;
  transform: translateY(-20%) translateY(-12px) translateX(-50%) !important;
  border-radius: 10%;
  width: auto !important;
  padding-left: 5px;
  padding-right: 5px;
  height: 20px !important;
}

.v-slider--horizontal .v-slider__thumb-label > * {
  transform: none !important;
  -webkit-transform: none !important;
}
</style>
